module.exports = __webpack_public_path__ + "img/full0-min.904c2fc0.png";